import React from "react";
import messages from "./messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { ItemLine } from "@modules/Purchasing/Components/OrderDescription/OrderDescriptionItems/ItemLine";
import { Rate } from "@Shared/Components/Rate/Rate";

export const AdvancePaymentItem = ({
  prepaidCents,
}: {
  prepaidCents: number;
}) => {
  return (
    <>
      {prepaidCents > 0 && (
        <ItemLine
          title={<FormattedMessage {...messages.advancePayment} />}
          amount={<Rate cents={prepaidCents} currency={"EUR"} />}
          isSubstract
        />
      )}
    </>
  );
};
